import { Navigate } from 'react-router-dom';
import { getAuthentication, getSchoolContext } from './hooks/useAuthentication';

export enum RoutesEnum {
  DEFAULT,
  RESOURCE_HUB,
  PODCAST,
  LEARN,
  REPORTING_TOOLS,
  MANAGE_STAFF,
  MISSION,
  BOOKMARK,
  SEARCH,
}

export function isAuthorized(route: RoutesEnum) {
  const schoolContext = getSchoolContext();
  const authentication = getAuthentication();
  if (!schoolContext?.subscription) return false;
  const { search, resourceHub, mission, learn, bookmark } = schoolContext.subscription;

  switch (route) {
    case RoutesEnum.DEFAULT:
      return true;
    case RoutesEnum.RESOURCE_HUB:
      return resourceHub;
    case RoutesEnum.LEARN:
      return learn;
    case RoutesEnum.MISSION:
      return mission;
    case RoutesEnum.BOOKMARK:
      return bookmark;
    case RoutesEnum.SEARCH:
      return search;
    case RoutesEnum.REPORTING_TOOLS:
      return true;
    case RoutesEnum.MANAGE_STAFF:
      return authentication?.user?.access_control_list?.manageStaff;
    default:
      return false;
  }
}

export default function withAuthGuard(WrappedComponent: React.ReactNode, route: RoutesEnum) {
  const autentication = getAuthentication();

  if (!autentication || !autentication.user) {
    return <Navigate to="/login" />;
  }

  if (!isAuthorized(route)) {
    return <Navigate to="/not-authorized" />;
  }

  return WrappedComponent;
}
